import React from 'react';
import './index.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2024 Prathamesh Akole</p>
        </footer>
    );
}

export default Footer;